import useUrlParams from "./urlParms";

export default function useSearchFilerUtils() {
  const { setUrlParams, getUrlParams } = useUrlParams();

  const onSortedChange = (state) => {
    const isStateValidArray = Array.isArray(state) && state.length > 0;
    const order_by = isStateValidArray ? state[0]?.id : undefined;
    const order = state[0]?.desc ? "desc" : "asc";

    if (order_by && order) {
      setUrlParams({
        order,
        order_by,
      });
    }
  };

  const onFilteredChange = (state) => {
    const isStateValidArray = Array.isArray(state) && state.length > 0;
    const q_field = isStateValidArray ? state[0]?.id : undefined;
    const q = isStateValidArray && state[0]?.value;

    if (!q) {
      setUrlParams({
        q_field: "",
        q: "",
      });
    }

    if (q_field && q) {
      setUrlParams({
        q_field,
        q,
      });
    }
  };

  const getPagesCountFromData = (data) => {
    const pageSize = getUrlParams()?.pageSize || 25;

    const pages = Math.ceil(data?.count / pageSize);
    return pages;
  };

  return { onSortedChange, onFilteredChange, getPagesCountFromData };
}
